import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export type SystemStateType =
    | 'idle'
    | 'offline'
    | 'server_unavailable'
    | 'unexpected_error';

export type SystemState = {
    type: SystemStateType;
    message?: string;
};

@Injectable({
    providedIn: 'root',
})
export class SystemStateService {
    private readonly stateSubject = new BehaviorSubject<SystemState>({type: 'idle'});
    readonly state$ = this.stateSubject.asObservable();

    get current(): SystemState {
        return this.stateSubject.value;
    }

    showOffline(message?: string): void {
        this.stateSubject.next({
            type: 'offline',
            message: message || 'Your internet connection appears to be offline.',
        });
    }

    showServerUnavailable(message?: string): void {
        this.stateSubject.next({
            type: 'server_unavailable',
            message: message || 'The Kyra server is temporarily unavailable. Please try again shortly.',
        });
    }

    showUnexpectedError(message?: string): void {
        this.stateSubject.next({
            type: 'unexpected_error',
            message: message || 'Something unexpected happened. Please refresh and try again.',
        });
    }

    clear(): void {
        this.stateSubject.next({type: 'idle'});
    }
}
